module.exports = "mat-form-field {\n  width: 150px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/select-motivo-rechazo/select-motivo-rechazo.component.scss
// module id = ./src/app/shared-components/select-motivo-rechazo/select-motivo-rechazo.component.scss
// module chunks = main